/*
=========================================================
NUPEP Cart Framework
Version 6.0.0
=========================================================
*/

window.NUPEP = window.NUPEP || {};

NUPEP.Cart = {
  async refresh() {
    const cart = await NUPEP.CartAPI.get();

    NUPEP.CartRenderer.render(cart);
  },

  init() {
    console.log("NUPEP Cart Framework Initialised");

    NUPEP.CartEvents.bind();
  },
};

document.addEventListener(
  "DOMContentLoaded",

  () => NUPEP.Cart.init(),
);
